module.exports = __webpack_public_path__ + "static/media/ProfBorongLin.2d4e6aaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/comp/sub1/ProfBorongLin.jpg
// module id = 197
// module chunks = 0